import { createFileRoute } from '@tanstack/react-router';

type OrderSearchParams = {
  tab?: string;
  q?: string;
  page?: number;
  state?: string;
  sortField?: string;
  sortDir?: string;
  stockLocationId?: string;
  dateFrom?: string;
  dateTo?: string;
  paymentMethod?: string;
  fulfillmentStatus?: string;
  carrier?: string;
  amountMin?: string;
  amountMax?: string;
};

export const Route = createFileRoute('/orders/')({
  validateSearch: (search: Record<string, unknown>): OrderSearchParams => ({
    tab: typeof search.tab === 'string' ? search.tab : undefined,
    q: typeof search.q === 'string' ? search.q : undefined,
    page:
      typeof search.page === 'number'
        ? search.page
        : typeof search.page === 'string' && Number.isFinite(Number(search.page))
          ? Number(search.page)
          : undefined,
    state: typeof search.state === 'string' ? search.state : undefined,
    sortField: typeof search.sortField === 'string' ? search.sortField : undefined,
    sortDir: typeof search.sortDir === 'string' ? search.sortDir : undefined,
    stockLocationId: typeof search.stockLocationId === 'string' ? search.stockLocationId : undefined,
    dateFrom: typeof search.dateFrom === 'string' ? search.dateFrom : undefined,
    dateTo: typeof search.dateTo === 'string' ? search.dateTo : undefined,
    paymentMethod: typeof search.paymentMethod === 'string' ? search.paymentMethod : undefined,
    fulfillmentStatus: typeof search.fulfillmentStatus === 'string' ? search.fulfillmentStatus : undefined,
    carrier: typeof search.carrier === 'string' ? search.carrier : undefined,
    amountMin: typeof search.amountMin === 'string' ? search.amountMin : undefined,
    amountMax: typeof search.amountMax === 'string' ? search.amountMax : undefined,
  }),
});
